(function () {
  'use strict';

  /* @ngdoc object
   * @name payment
   * @description
   *
   */
  angular
    .module('paymentPlannedActual', [
      'ui.router'
    ]);
}());
